import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
@Component({
  selector: 'app-pnc-model',
  templateUrl: './pnc-model.component.html',
  styleUrls: ['./pnc-model.component.css'],
})
export class PncModelComponent implements OnInit {
        @Input() benID:any
        @Input() AlraedyDataAdded:any
        
  pncForm: FormGroup;
  mhsList: any[]=[];
  bfList: any[]=[];
  fpaList: any[]=[];
  imztnList: any[]=[];
  referredist: any;

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.getMHS();
    this.getBF();
    this.getFPA();
    this.getImminization();
    this.getReferred();

      if(this.AlraedyDataAdded){
  setTimeout(() => {
    this.pncForm.patchValue(this.AlraedyDataAdded)
  }, 500);
  }
  }

  formInIt() {
    this.pncForm = this.fb.group({
      health_status_id: [],
      breastfeeding_id: [],
      if_calcium_continued: [false],
      family_planning_advice_id: [],
      infant_immune_status_id: [],
      consult_refer_to_id: [],
      beneficiary_id : this.benID
    });
  }


  getMHS() {
      this.regService.get(`masters/masters/getallmotherhealthstatus`).subscribe({
          next: (res) => {
            if (res.status == 'OK') {
              this.mhsList = res.data ?? [];
              this.toastr.success(res.message);
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
    }
  getBF() {
      this.regService.get(`masters/masters/getallbreastfeedingstatus`).subscribe({
          next: (res) => {
            if (res.status == 'OK') {
              this.bfList = res.data ?? [];
              this.toastr.success(res.message);
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
    }
  getFPA() {
      this.regService.get(`masters/masters/getallfamilyplanningadvices`).subscribe({
          next: (res) => {
            if (res.status == 'OK') {
              this.fpaList = res.data ?? [];
              this.toastr.success(res.message);
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
    }
  getImminization() {
      this.regService.get(`masters/masters/getallinfantimmunizationstatus`).subscribe({
          next: (res) => {
            if (res.status == 'OK') {
              this.imztnList = res.data ?? [];
              this.toastr.success(res.message);
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
    }

    getReferred() {
    this.regService.get(`masters/masters/getallreferredto`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.referredist = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

    onSave(){
    this.toastr.success("Records Saved After POC Submition")
    setTimeout(() => {
      console.log('PNC Data',this.pncForm.value)
      this.activeModal.close(this.pncForm.value)
    }, 200);
   
  }
}
